/* ------------------------------------------------------------------------------
@name: Section5
@description: Section5
--------------------------------------------------------------------------------- */

const Section5 = (() => {
  // - section5
  const handleSection5 = () => {
    const controller = new ScrollMagic.Controller();

    const section_5 = new ScrollMagic.Scene({
      triggerElement: ".section-5-trigger-1",
      triggerHook: 0.8,
    })
      .setTween(".bar-info-4", 0.3, {
        opacity: 1,
      })
      .addTo(controller);

    const section_5a = new ScrollMagic.Scene({
      triggerElement: ".section-5-trigger-2",
      triggerHook: 0.8,
    })
      .setTween(".bar-info-4", 0.3, {
        opacity: 0,
      })
      .addTo(controller);

    const section_5b = new ScrollMagic.Scene({
      triggerElement: ".section-5-trigger-2",
      triggerHook: 0.8,
    })
      .setTween(".bar-info-5", 0.3, {
        opacity: 1,
      })
      .addTo(controller);

    const section_5c = new ScrollMagic.Scene({
      triggerElement: ".section-5-trigger-3",
      triggerHook: 0.8,
    })
      .setTween(".bar-info-5", 0.3, {
        opacity: 0,
      })
      .addTo(controller);

    const section_5d = new ScrollMagic.Scene({
      triggerElement: ".section-5-trigger-1",
      triggerHook: 0.2,
    })
      .setTween(".navbar-2", 0.2, {
        opacity: 1,
      })
      .addTo(controller);

    const section_5e = new ScrollMagic.Scene({
      triggerElement: ".section-5-trigger-3",
      triggerHook: 0.2,
    })
      .setTween(".navbar-2", 0.2, {
        opacity: 0,
      })
      .addTo(controller);

    $(".kuis-2-opsi-a").click(function () {
      $(".kuis-2-pertanyaan").addClass("kuis-hide");
      setTimeout(function () {
        $(".kuis-2-pertanyaan").addClass("hidden");
        $(".kuis-2-jawaban-ab").removeClass("hidden");
        setTimeout(function () {
          $(".kuis-2-jawaban-ab").removeClass("kuis-hide");
        }, 150);
      }, 150);
    });

    $(".kuis-2-opsi-b").click(function () {
      $(".kuis-2-pertanyaan").addClass("kuis-hide");
      setTimeout(function () {
        $(".kuis-2-pertanyaan").addClass("hidden");
        $(".kuis-2-jawaban-ab").removeClass("hidden");
        setTimeout(function () {
          $(".kuis-2-jawaban-ab").removeClass("kuis-hide");
        }, 150);
      }, 150);
    });

    $(".kuis-2-opsi-c").click(function () {
      $(".kuis-2-pertanyaan").addClass("kuis-hide");
      setTimeout(function () {
        $(".kuis-2-pertanyaan").addClass("hidden");
        $(".kuis-2-jawaban-c").removeClass("hidden");
        setTimeout(function () {
          $(".kuis-2-jawaban-c").removeClass("kuis-hide");
        }, 150);
      }, 150);
    });

    $(".btn-hello").click(function () {
      $(".audio-hello")[0].play();
    });
    
    $(".btn-gas").click(function () {
      $(".audio-gas")[0].play();
    });

    //highlight navigation
    $(window).scroll(function () {
      var windowpos = $(window).scrollTop();
      $(".navbar-2 li .penanda").removeClass("active");

      if (windowpos > $(".penanda-2-start-1").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-1").addClass("active");
      }

      if (windowpos > $(".penanda-2-start-2").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-2").addClass("active");
      }

      if (windowpos > $(".penanda-2-start-3").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-3").addClass("active");
      }

      if (windowpos > $(".penanda-2-start-4").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-4").addClass("active");
      }

      if (windowpos > $(".penanda-2-start-5").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-5").addClass("active");
      }

      if (windowpos > $(".penanda-2-start-6").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-6").addClass("active");
      }

      if (windowpos > $(".penanda-2-start-7").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-7").addClass("active");
      }

      if (windowpos > $(".penanda-2-start-8").offset().top) {
        $(".navbar-2 li .penanda").removeClass("active");
        $(".penanda-2-8").addClass("active");
      }
    });

    $(".btn-scrollto-3").click(function () {
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $(".penanda-3-start-1").offset().top,
        },
        1000
      );
    });
  };

  // - init
  const init = () => {
    handleSection5();
  };

  return {
    init,
  };
})();

export default Section5;
